import WizardDialog, { WizardModalDialogProps } from "designSystem/components/wizard/WizardDialog";
import { useLocalReactionStore } from "designSystem/hooks";
import { useLocale } from "designSystem/locale";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import ColorAllocationManagePage from "./ColorAllocationManagePage";
import { createColorwayAllocationManageStore } from "./ColorwayAllocationManageService";
import { ColorwayAllocationManageStore, ColorwayAllocationManageStoreContext } from "./ColorwayAllocationManageStore";
import { UpdateSupplierRequestTable } from "./UpdateSupplierRequestTable";

export const ColorwayAllocationManageDialog: FunctionComponent<WizardModalDialogProps<ColorwayAllocationManageStore>> = observer((props) => {
	const { actionController, onClose, onSave, ...otherProps } = props;
	const loc = useLocale();
	const store = useLocalReactionStore(() => createColorwayAllocationManageStore(actionController, loc, onClose, onSave));
	
	return (
		<>
			{store && (
				<ColorwayAllocationManageStoreContext.Provider value={store}>
					<WizardDialog
						{...otherProps}
						contentPadding={0}
						// do this to prevent the MUI event from disabling the event of Dojo widget, for example, in the case of Form, when we try to select a value from drop-down, 
						// the focus event from MUI would disable the onMouseUp event of FilteringSelect widget
						disableEnforceFocus
						fullHeight
						pages={[ColorAllocationManagePage, UpdateSupplierRequestTable]}
						store={store}
						supportStepInformation
						width={1000}
					/>
				</ColorwayAllocationManageStoreContext.Provider>
			)}
		</>
	);
});

export default ColorwayAllocationManageDialog;
